import { BroadcastFormValues } from '../BroadcastForm/form';
import { NOTIFICATION_LOCALES } from '../constants';

import { BroadcastNotification, BroadcastNotificationRequest } from 'v2/types/BroadcastNotificationModel';

export const mapBroadcastToForm = (notification: BroadcastNotification): BroadcastFormValues => {
  const primaryLocale = notification.data['ru-RU'] ?? Object.values(notification.data)[0];

  return {
    categorySubType: notification.categorySubType,
    isPinned: notification.isPinned,
    iconId: primaryLocale?.iconId ?? '',
    content: {
      title: primaryLocale?.title ?? '',
      description: primaryLocale?.description ?? '',
      buttonText: primaryLocale?.buttonText ?? '',
      link: primaryLocale?.link ?? '',
    },
    metadata: Object.entries(notification.metadata ?? {}).map(([key, value]) => ({ key, value })),
  };
};

export const mapFormToUpdateDto = (values: BroadcastFormValues): BroadcastNotificationRequest => {
  const localeData = {
    ...values.content,
    ...(values.iconId ? { iconId: values.iconId } : {}),
  };
  const data = Object.fromEntries(NOTIFICATION_LOCALES.map((l) => [l.code, localeData]));

  const metadata: Record<string, string> | null =
    values.metadata.length > 0
      ? Object.fromEntries(values.metadata.filter((m) => m.key).map((m) => [m.key, m.value]))
      : null;

  return {
    categorySubType: values.categorySubType,
    data,
    metadata,
    isPinned: values.isPinned,
  };
};
